var _path, _g, _linearGradient, _path2, _linearGradient2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNbLogoKachelGrauRgbSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50 50h-50"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D9DADC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.336 50h-.336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 49.664h50v.336h-50z"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 483.394,
    y1: 878.214,
    x2: 486.363,
    y2: 875.246,
    gradientTransform: "matrix(6.72 0 0 -6.72 -3233.591 5916.997)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414650"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M25 10.887c-7.762 0-14.113 6.317-14.113 14.113 0 7.762 6.317 14.113 14.113 14.113 7.762 0 14.113-6.317 14.113-14.113s-6.317-14.113-14.113-14.113z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 483.629,
    y1: 877.978,
    x2: 486.174,
    y2: 875.433,
    gradientTransform: "matrix(6.72 0 0 -6.72 -3233.591 5916.997)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6F6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M25 12.937c-6.653 0-12.063 5.41-12.063 12.063s5.41 12.063 12.063 12.063 12.063-5.41 12.063-12.063-5.41-12.063-12.063-12.063z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#414650",
    d: "M25 13.944c-6.082 0-11.055 4.94-11.055 11.056 0 6.082 4.939 11.055 11.055 11.055 6.082 0 11.055-4.939 11.055-11.055 0-6.082-4.973-11.056-11.055-11.056z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.857 17.742s-1.579-.336-2.554 2.116c3.764 3.966 1.243 11.828.538 12.399 2.823-.738 6.418-13.608 2.016-14.515zm-4.166 4.267s-2.251-.537-3.629 1.983c4.032-1.143 6.283 2.789 5.578 6.048 1.814-2.99.84-7.393-1.949-8.031zm8.904-.705c-3.965 2.789-2.318 9.61-1.109 10.551-1.68-8.098 3.764-9.711 6.452-8.77-.772-2.017-3.495-3.092-5.343-1.781zm-3.595-7.36c6.082 0 11.055 4.94 11.055 11.056 0 6.082-4.939 11.055-11.055 11.055-6.082 0-11.055-4.939-11.055-11.055 0-6.082 4.973-11.056 11.055-11.056m0-.168c-6.183 0-11.223 5.007-11.223 11.224 0 6.183 5.041 11.223 11.223 11.223s11.223-5.04 11.223-11.223c0-6.217-5.007-11.224-11.223-11.224zm0-.839c6.653 0 12.063 5.41 12.063 12.063s-5.41 12.063-12.063 12.063-12.063-5.41-12.063-12.063 5.41-12.063 12.063-12.063m0-.202c-6.754 0-12.231 5.511-12.231 12.265s5.477 12.231 12.231 12.231 12.231-5.477 12.231-12.231-5.477-12.265-12.231-12.265z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F434E",
    d: "M25 10.887c7.762 0 14.113 6.317 14.113 14.113 0 7.762-6.317 14.113-14.113 14.113-7.762 0-14.113-6.317-14.113-14.113s6.351-14.113 14.113-14.113m0-.168c-7.896 0-14.281 6.385-14.281 14.281s6.385 14.281 14.281 14.281 14.281-6.385 14.281-14.281-6.385-14.281-14.281-14.281z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbLogoKachelGrauRgbSmall);
export default __webpack_public_path__ + "static/media/N+B_Logo-Kachel-grau_RGB--small.efcfd44008253fb1b2fe1ee00d205827.svg";
export { ForwardRef as ReactComponent };